export default __webpack_public_path__ + "landingPageIntegrate.html";